import { tap, concatMap, map } from 'rxjs';
import { CrudServiceBase, RxUtils, TypeUtils } from '@utils';
import { logger } from '@services/logger';
import { httpService } from '@services/http';
import { QuotationItemService } from '@services/quotation-item';
import { Quotation } from './quotation.class';

type Entity = Quotation;

export class QuotationService extends CrudServiceBase<Entity> {
	constructor() {
		super(Quotation, 'quotation');
	}

	quotationItem(quotationId: string) {
		return new QuotationItemService(quotationId);
	}

	getLatest(disableLoader = false) {
		return httpService.get<Quotation[]>(this.getUrl(), 'latest/one', { disableLoader }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getLatest.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(Quotation, result)?.[0])
		);
	}
}

export const quotationService = new QuotationService();
